import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';

export function removeRegionalDistrictFromJsonQuery(jsonQuery: TJsonQuery, id: number): TGeoValue[] {
  const geo = getGeoValue()(jsonQuery);

  if (!geo) {
    return [];
  }

  const value = geo.filter(
    item => item.type !== 'regional_district_id' || (item.type === 'regional_district_id' && item.id !== id),
  );

  return value.length === 0 ? [] : value;
}
